import React from 'react';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography, Button } from '@mui/material';
import XLSX from "sheetjs-style";

const ShippingSummary = ({ data }) => {
  const totals = {
    kg: data.reduce((sum, row) => sum + (Number(row.shipmentQuantity) || 0), 0),
    shipments: data.length,
    distinctSI: new Set(data.map(row => row.finalShippingInstructionNumber)).size,
    containers: {
      '20': data.reduce((sum, row) => sum + (Number(row.toBeShippedBy20) || 0), 0),
      '40': data.reduce((sum, row) => sum + (Number(row.toBeShippedBy40) || 0), 0),
      '40HC': data.reduce((sum, row) => sum + (Number(row.toBeShippedBy40HC) || 0), 0),
      'FT': data.reduce((sum, row) => sum + (Number(row.toBeShippedByFtl) || 0), 0)
    },
    totalUSD: data.reduce((sum, row) => sum + ((Number(row.salesOrderUsdFinalPrice) || 0) * (Number(row.shipmentQuantity) || 0)), 0),
    totalFreight: data.reduce((sum, row) => sum + ((Number(row.actualFreightPriceUsd) || 0) * (Number(row.shipmentQuantity) || 0)), 0),
    totalInsurance: data.reduce((sum, row) => sum + ((Number(row.actualInsuranceCostUsd) || 0) * (Number(row.shipmentQuantity) || 0)), 0)
  };


  const freightUsdPerKg = data.reduce((sum, row) => {
    const freight = Number(row.actualFreightPriceUsd) || 0;
    const kg = Number(row.shipmentQuantity) || 0;
    return kg ? freight / kg : 0;
  }, 0);

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    
    const sortedData = [...data].sort((a, b) => {
      const polA = (a.pointOfLoading || '').toLowerCase();
      const polB = (b.pointOfLoading || '').toLowerCase();
      return polA.localeCompare(polB);
    });

    const summaryData = [
      ['Total kg', 'shipment','20', '40', '40HC', 'FTL', 'Total USD', 'Total Freight USD', 'Total Insurance USD'],
      [
        totals.kg ? 
        {
          v: Number(totals.kg),
          t: 'n',
          z: '#,##0.0000'
        }:"",
       // totals.shipments,
        totals.distinctSI,
        totals.containers['20'],
        totals.containers['40'],
        totals.containers['40HC'],
        totals.containers.FT,
         totals.totalUSD ? {
          v: Number(totals.totalUSD),
          t: 'n',
          z: '#,##0.00'
        } : "",
        totals.totalFreight ? {
          v: Number(totals.totalFreight),
          t: 'n',
          z: '#,##0.00'
        } : "",
        totals.totalInsurance ? {
          v: Number(totals.totalInsurance),
          t: 'n',
          z: '#,##0.00'
        } : "",
      ],
      [''],
       ['SI','Port of Loading', 'Port of Discharge','Freight USD/kg','Insurance USD/kg','Debit Note USD/kg','Credit Note USD/kg','SO Incoterm', 'SO Price USD/kg', 'KG'],
      ...sortedData.map(row => [
        row?.finalShippingInstructionNumber || '',
        row?.pointOfLoading || '',
        row?.pointOfUnloading || '',
        row.actualFreightPriceUsd ? {
          v: Number(row?.actualFreightPriceUsd ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
        row.actualInsuranceCostUsd ? {
          v: Number(row?.actualInsuranceCostUsd ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
        row.debitNoteUsd ? {
          v: Number(row?.debitNoteUsd ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
        row.creditNoteUsd ? {
          v: Number(row?.creditNoteUsd ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
        row?.salesOrderIncoterm || '',
          row.salesOrderUsdFinalPrice ? {
          v: Number(row?.salesOrderUsdFinalPrice ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
         row.shipmentQuantity ? {
          v: Number(row?.shipmentQuantity ||0),
          t: 'n',
          z: '#,##0.0000'
        } : '',
      ])
    ];

    // Create and style summary sheet
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);
    
    // Set column widths
    summarySheet['!cols'] = [
      { wch: 15 }, // kg
      { wch: 10 }, // shipment
      { wch: 10 }, // 40HC
      { wch: 10 }, // 20
      { wch: 10 }, // FT
      { wch: 12 }  // Freight USD/kg
    ];

    // Apply number formats
    const range = XLSX.utils.decode_range(summarySheet['!ref']);
    for(let R = 2; R <= 2; R++) { // Format numbers in the data row
      for(let C = 0; C <= 4; C++) {
        const cell_ref = XLSX.utils.encode_cell({r: R, c: C});
        if(summarySheet[cell_ref]) {
          summarySheet[cell_ref].z = '#,##0.00';
        }
      }
    }

    // Add sheets to workbook
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');

    // Save file
    XLSX.writeFile(workbook, 'ShippingSummary.xlsx');
  };

  return (
    <Box>
      <Button 
        onClick={exportToExcel}
          disableElevation
          variant="outlined"
          size="small"
      >
        Export Summary
      </Button>
    </Box>
  );
};

export default ShippingSummary;